import debugFactory from "debug";

const NAMESPACE_ROOT = "otl";

/**
 * Creates a namespaced debug logger, e.g. createDebugLogger("signalr:connection")
 * logs under "otl:signalr:connection". Enable in the browser console with:
 *   localStorage.debug = "otl:*"          // everything
 *   localStorage.debug = "otl:signalr:*"  // just signalr
 * then reload. Disable with localStorage.removeItem("debug").
 */
export const createDebugLogger = (scope: string) => {
  const instance = debugFactory(`${NAMESPACE_ROOT}:${scope}`);
  return (message: string, ...args: unknown[]): void => {
    instance(message, ...args);
  };
};
